export default __webpack_public_path__ + "static/media/Background_00201.ec29852c.png";